import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { settingsMenuAnimations } from "@/_utility/animations";
import { shareReplay, map } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { UserService } from "@/_services";
import UserModel = UserDm.UserModel;
import { UserDm, DismissedBanner } from "@/_models";
import { OnboardingGuideService } from "@/_services/onboarding-guide.service";
import { USER_IS_AT_LEAST_ADMIN } from "@/_services";

@Component({
    selector: "app-mobile-menu",
    templateUrl: "./mobile-menu.component.html",
    styleUrls: ["./mobile-menu.component.scss"],
    animations: settingsMenuAnimations,
})
export class MobileMenuComponent implements OnInit, OnDestroy {
    currentUser$: Observable<UserModel>;
    isAdmin$: Observable<boolean>;
    asapFormId$: Observable<string | null>;
    hasNotDismissedBanner$: Observable<boolean>;
    private destroy$ = new Subject<void>();
    isMenuOpened: boolean;

    constructor(
        private userService: UserService,
        private onboardingGuideService: OnboardingGuideService,
        @Inject(USER_IS_AT_LEAST_ADMIN)
        isAdmin$: Observable<boolean>,
    ) {
        this.isAdmin$ = isAdmin$;
    }

    ngOnInit() {
        this.currentUser$ = this.userService
            .getCurrentUserAsync()
            .pipe(shareReplay());

        this.asapFormId$ = this.onboardingGuideService.asapFormId$;

        this.hasNotDismissedBanner$ = this.currentUser$.pipe(
            map((user) => {
                const dismissed = user?.dismissedBanners || [];
                return !dismissed.includes(DismissedBanner.OnboardingGuide);
            }),
            shareReplay(1),
        );
    }

    toggleMenu(state: boolean) {
        this.isMenuOpened = state;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    isOnboardingCompleted(): boolean {
        const steps = this.onboardingGuideService.getStepsSnapshot();
        return steps.length > 0 && steps.every((step) => step.completed);
    }
}
